import React from 'react';
import { useAppContext } from 'Context/ReactAppContext';
import { getNationalities } from '@clubmed/domains-service';
const nationalitiesLanguageKey = {
  fr: 'fr-CH',
  de: 'de-CH',
  en: 'en-CH',
  zh: 'zh-TW',
  ru: 'ru-RU',
};
const DEFAULT_LANGUAGE = 'en';
export const useCountryList = (): {
  name: string;
  value: string;
}[] => {
  const appContext = useAppContext();
  const exactLocaleNationalities = getNationalities(appContext.locale);

  if (exactLocaleNationalities.length) {
    return exactLocaleNationalities
      .map(({ country, codeIso2 }) => ({
        name: country,
        value: codeIso2,
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  const language = appContext.locale.split('-')[0];
  const locale = nationalitiesLanguageKey?.[language] || nationalitiesLanguageKey[DEFAULT_LANGUAGE];
  return (getNationalities(locale) || [])
    .map(({ country, codeIso2 }) => ({
      name: country,
      value: codeIso2,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};
